import { useInfoCard } from '../hooks/useInfoCard';

export function InfoCardImageContainer(): JSX.Element | null {
	const { imageUrl, isFullModeStyle, handles } = useInfoCard();

	if (isFullModeStyle) return null;

	function renderStyles(): Record<string, unknown> {
		return { objectFit: 'cover' };
	}

	return (
		<div className={`${handles.infoCardImageContainer} w-50-ns`}>
			<img className={`${handles.infoCardImage}`} src={imageUrl} alt="Alt" style={renderStyles()} />
		</div>
	);
}
